export default __webpack_public_path__ + "static/media/RuthRendering.e5b0f7ff.jpg";